module.exports = "https://milano-network.servercdn.it/static/img/thick-arrow-black.svg?679990feb40a95a21217c905e1f055e7";